<label [for]="id" [ngClass]="['control-label', _labelClass]">Groupement parc&nbsp;{{ _mandatory? '*' : '' }}:</label>
<div [ngClass]="_fieldClass">
	<extended-filterable-select
		[id]="id"
		[list]="groupements"
		[inputClass]="'form-control'"
		[labelGetter]="getGroupementLabel"
		[disabled]="disabled"
		[selectedItem]="selectedGroupement"
		(selectedItemChange)="onSelectedGroupementChange($event)"
		>
	</extended-filterable-select>
</div>